import { render, staticRenderFns } from "./TSAdWidget.vue?vue&type=template&id=654888bc&scoped=true&"
import script from "./TSAdWidget.vue?vue&type=script&lang=js&"
export * from "./TSAdWidget.vue?vue&type=script&lang=js&"
import style0 from "./TSAdWidget.vue?vue&type=style&index=0&id=654888bc&lang=scss&scoped=true&"
import style1 from "./TSAdWidget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654888bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
